module.exports = __webpack_public_path__ + "f38a61e25305f5aa01985fa40d8e83b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/press_teaser_201610_sz.jpg
// module id = 650
// module chunks = 0